import * as React from 'react'

const Wheel1 = props => {
  const gradientColors = (
    <>
      <stop stopColor="#003535" />
      <stop offset="0.1" stopColor="#00A2A1" />
      <stop offset="0.15" stopColor="white" />
      <stop offset="0.22" stopColor="#1FDAD9" />
      <stop offset="0.34" stopColor="#00A2A1" />
      <stop offset="0.5" stopColor="#00D5D4" />
      <stop offset="0.66" stopColor="#1FDAD9" />
      <stop offset="0.72" stopColor="#61E5E4" />
      <stop offset="0.77" stopColor="white" />
      <stop offset="0.83" stopColor="#00A2A1" />
      <stop offset="1" stopColor="#003535" />
    </>
  )
  return (
    <svg
      viewBox="0 0 366 366"
      preserveAspectRatio="xMidYMid meet"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M182.544 365.088C283.36 365.088 365.088 283.36 365.088 182.544C365.088 81.7278 283.36 0 182.544 0C81.7278 0 0 81.7278 0 182.544C0 283.36 81.7278 365.088 182.544 365.088Z"
        fill="#383E45"
      />
      <path
        d="M182.544 365.088C283.36 365.088 365.088 283.36 365.088 182.544C365.088 81.7278 283.36 0 182.544 0C81.7278 0 0 81.7278 0 182.544C0 283.36 81.7278 365.088 182.544 365.088Z"
        fill="url(#paint0_linear_7794_18774)"
      />
      <path
        d="M182.545 363.263C282.353 363.263 363.264 282.352 363.264 182.544C363.264 82.735 282.353 1.82422 182.545 1.82422C82.736 1.82422 1.8252 82.735 1.8252 182.544C1.8252 282.352 82.736 363.263 182.545 363.263Z"
        fill="url(#paint1_radial_7794_18774)"
      />
      <path
        d="M182.544 346.102C272.876 346.102 346.105 272.874 346.105 182.541C346.105 92.2092 272.876 18.9805 182.544 18.9805C92.2121 18.9805 18.9834 92.2092 18.9834 182.541C18.9834 272.874 92.2121 346.102 182.544 346.102Z"
        fill="url(#paint2_linear_7794_18774)"
      />
      <path
        d="M182.544 343.182C271.262 343.182 343.183 271.261 343.183 182.543C343.183 93.8247 271.262 21.9043 182.544 21.9043C93.8257 21.9043 21.9053 93.8247 21.9053 182.543C21.9053 271.261 93.8257 343.182 182.544 343.182Z"
        fill="url(#paint3_radial_7794_18774)"
      />
      <path
        d="M182.544 345.007C272.271 345.007 345.009 272.269 345.009 182.542C345.009 92.8145 272.271 20.0762 182.544 20.0762C92.8165 20.0762 20.0781 92.8145 20.0781 182.542C20.0781 272.269 92.8165 345.007 182.544 345.007Z"
        fill="url(#paint4_linear_7794_18774)"
      />
      <path
        d="M182.544 341.721C270.457 341.721 341.724 270.454 341.724 182.541C341.724 94.6285 270.457 23.3613 182.544 23.3613C94.6315 23.3613 23.3643 94.6285 23.3643 182.541C23.3643 270.454 94.6315 341.721 182.544 341.721Z"
        fill="url(#paint5_linear_7794_18774)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_7794_18774"
          x1="332.296"
          y1="32.7945"
          x2="33.2414"
          y2="331.849"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <radialGradient
          id="paint1_radial_7794_18774"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(182.545 182.544) scale(180.719)">
          <stop stopColor="#383E45" />
          <stop offset="1" stopColor="#1E272E" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_7794_18774"
          x1="316.721"
          y1="48.3643"
          x2="48.7682"
          y2="316.318"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
        <radialGradient
          id="paint3_radial_7794_18774"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(181.902 181.833) scale(159.939 159.939)">
          <stop stopColor="#383E45" />
          <stop offset="1" stopColor="#1E272E" />
        </radialGradient>
        <linearGradient
          id="paint4_linear_7794_18774"
          x1="182.544"
          y1="345.007"
          x2="182.544"
          y2="20.0784"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#00D5D4" />
          <stop offset="0.28" stopColor="#00A2A1" />
          <stop offset="0.35" stopColor="#001F1F" />
          <stop offset="0.44" stopColor="#003535" />
          <stop offset="0.49" stopColor="#001F1F" />
          <stop offset="0.53" stopColor="#DBF9F9" />
          <stop offset="0.85" stopColor="#61E5E4" />
          <stop offset="1" stopColor="#1FDAD9" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_7794_18774"
          x1="313.129"
          y1="51.9588"
          x2="52.3516"
          y2="312.734"
          gradientUnits="userSpaceOnUse">
          {gradientColors}
        </linearGradient>
      </defs>
    </svg>
  )
}

export default Wheel1
